import qs from 'qs';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IS_SUCCESS_RESPONSE } from 'src/helpers';
import { axiosInstanceWithoutAuth } from 'src/services/axiosSetup';
import InfiniteProgressBar from 'src/shadcn/components/custom/InfiniteProgressBar';
import { toast } from 'src/shadcn/components/ui/use-toast';

type Props = {}

const UserConnect = (props: Props) => {

    const { search } = useLocation();
    const navigate = useNavigate();
    const [data, setdata] = useState<any>({})


    useEffect(() => {

        let _data: any = search && qs.parse(search?.replace("/", ""), { ignoreQueryPrefix: true });
        // console.log("query params", _data);

        if (Object.values(_data).length > 0) {
            if (_data?.api_url && _data?.post_data && _data?.redirect_to) {
                setdata(_data);
                handleApiToRedirect(_data);
                // console.log("handle api");
                // const apiTest = axios.get("http://192.168.31.46:3000")
            }
            else {
                toast({
                    variant: "destructive",
                    title: "api_url, post_data or redirect_to is missing in query params",
                    description: "",
                });
            }
        }

        return () => { }
    }, [search])


    const handleApiToRedirect = async (data: any) => {
        try {
            // console.log("handleApiToRedirect", data);

            let { api_url, post_data } = data
            post_data = post_data ? JSON.parse(post_data) : {};
            // console.log({ api_url, post_data });
            const apiresp = await axiosInstanceWithoutAuth.post(api_url, post_data).then(data => data.data);
            if (IS_SUCCESS_RESPONSE(apiresp)) {
                navigate(data.redirect_to);
            }
            // console.log({ apiresp });

        } catch (error) {
            console.log("error in handleApiToRedirect", error);

        }
    }


    return (
        <div>
            <div className=" my-4 text-center">
                <div className="my-4 w-full h-[100vh] ">
                    <div className="space-y-4 mt-[50vh]">
                        <div>Loading ....</div>
                        <div className="mx-auto max-w-xs ">
                            <InfiniteProgressBar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserConnect